import { useSessionStore } from "../../../state/src/useSessionStore";

/**
 * Headers sent on every BFF request. Mirrors kiosk/session context so the BFF
 * can attach agentid, unitprofileid, qrCodeNumber, and phoneNumber to structured logs.
 */
export function buildBffRequestHeaders(extra?: HeadersInit): HeadersInit {
  const { agentId, unitProfileId, qrCodeNumber, phoneNumber } =
    (useSessionStore as any).getState?.() || {};
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  if (agentId) headers["x-agent-id"] = String(agentId);
  if (unitProfileId) headers["x-unit-profile-id"] = String(unitProfileId);
  if (qrCodeNumber) headers["x-qr-no"] = String(qrCodeNumber);

  const digits =
    phoneNumber != null && phoneNumber !== ""
      ? String(phoneNumber).replace(/\D/g, "")
      : "";
  if (digits.length >= 10 && digits.length <= 15) {
    headers["x-consumer-phone"] = digits;
  }

  return { ...headers, ...(extra as any) };
}
